import DriverCandidatureDeleteRequest from "../../../../api/raily/driver/candidature/delete/driver-candidature-delete.request";
import DriverCandidatureDeleteParams from "./driver-candidature-delete-params";

const create = (
  params: DriverCandidatureDeleteParams,
): DriverCandidatureDeleteRequest => {
  return {
    driverUuid: params.driverUuid,
  };
};

const driverCandidatureDeleteParamsFactory = {
  create,
};

export default driverCandidatureDeleteParamsFactory;
